import React, {FC} from "react";
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import StripePayment from "../../components/StripePayment";

/** `cart` / `orderHistory`: после успеха фронт шлёт `confirm-payment-success` (на бэке один retrieve PI и CARD_PAID); вебхук только проверка в лог. */
export type StripePaymentModalContext = "cart" | "orderHistory";

export type StripePaymentModalOrderData = {
    orderId?: string;
    poNumber?: string;
    namePo?: string;
    dealershipId?: number | string;
    customerEmail?: string;
    customerName?: string;
    description?: string;
};

export type StripePaymentModalProps = {
    isOpen: boolean;
    onClose: () => void;
    /** Источник: от этого зависят ожидания к `onPaymentSuccess` у родителя (см. описание типа). */
    paymentContext: StripePaymentModalContext;
    amount: number;
    currency?: string;
    orderData?: StripePaymentModalOrderData;
    /** Ключ для `key` у Stripe (смена заказа / сессии). */
    stripeKey?: string | number;
    /** Вызывается после успешного `confirmPayment` и синхронизации с бэком (если был `paymentIntent.id`). */
    onPaymentSuccess: (paymentIntentId?: string) => void;
    onPaymentError: (message: string) => void;
};

/**
 * Модалка оплаты картой (Stripe Elements).
 * Родитель передаёт `onPaymentSuccess`: для `orderHistory` — обновить список заказов; для `cart` — навигация / сброс корзины без обновления строки в истории.
 */
export const StripePaymentModal: FC<StripePaymentModalProps> = ({
    isOpen,
    onClose,
    paymentContext,
    amount,
    currency = "usd",
    orderData,
    stripeKey = "stripe-payment",
    onPaymentSuccess,
    onPaymentError,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="lg"
            scrollBehavior="inside"
            isCentered
        >
            <ModalOverlay/>
            <ModalContent
                data-payment-context={paymentContext}
                mx={{base: 3, md: "auto"}}
                maxW={{base: "calc(100vw - 24px)", md: "600px"}}
            >
                <ModalHeader>Credit Card Payment</ModalHeader>
                <ModalCloseButton/>
                <ModalBody pb={6}>
                    {isOpen && (
                        <StripePayment
                            key={stripeKey}
                            inModal
                            amount={amount}
                            currency={currency}
                            onSuccess={onPaymentSuccess}
                            onError={onPaymentError}
                            onCancel={onClose}
                            orderData={orderData}
                        />
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default StripePaymentModal;
